import React, { type ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useDisabledModules } from '../hooks/useDisabledModules';
import { type ExchangeModule } from '../types/exchanges';

type RootState = { login: { role: string | null } };

/** Sends a user whose exchange has not bought `module` back to the home page. */
export default function RequireModule({
  module,
  children,
}: {
  module: ExchangeModule;
  children: ReactElement;
}): ReactElement | null {
  const role = useSelector((state: RootState) => state.login.role);
  const disabledModules = useDisabledModules();

  // AuthLayout fetches the user asynchronously; wait for it like RequireAdmin does
  if (role === null) return null;

  return disabledModules.includes(module) ? <Navigate to="/" replace /> : children;
}
